import React, {ReactElement} from "react";
import {IEditSelection} from "./EditState";

export interface IInsertOption {
    display: ReactElement
    insert: (textArea: IEditSelection) => IEditSelection
    option: string
    shortcut: string
}
const insertReplace = (edit: IEditSelection, replace: string) => {
    if (edit.selectionStart !== undefined && edit.selectionEnd !== undefined) {
        const selected = edit.script.slice(edit.selectionStart, edit.selectionEnd);
        const insert = replace.replace(/\[[^\]]+]/, selected);
        const selectionEnd = edit.script[edit.selectionEnd] === ":" && replace[replace.length - 1] === ":" ?
            edit.selectionEnd + 1 : edit.selectionEnd;

        edit.script = edit.script.slice(0, edit.selectionStart) + insert + edit.script.slice(selectionEnd);
        edit.selectionStart = edit.selectionEnd = edit.selectionStart + insert.length;
        edit.overrideSelection = true;
    } else {
        edit.script = replace + edit.script;
    }
    return edit;
}
const insert = (edit: IEditSelection, insert: string) => {
    if (edit.selectionStart !== undefined) {
        edit.script = edit.script.slice(0, edit.selectionStart) + insert + edit.script.slice(edit.selectionEnd);
    } else {
        edit.script = insert + edit.script;
    }
    return edit;
};
export const insertOptions: IInsertOption [] = [
    {
        display: <span><u>C</u>haracter</span>,
        insert: (selection) => {
            return insertReplace(selection, "CHARACTER([character]):");
        },
        option: "character",
        shortcut: "KeyC"
    },
    {
        display: <span>C<u>u</u>t</span>,
        insert: (selected) => {
            return insert(selected, "CUT: ");
        },
        option: "cut",
        shortcut: "KeyU"
    },
    {
        display: <span><u>G</u>esture</span>,
        insert: (selected) => {
            return insertReplace(selected, "GESTURE([gesture])");
        },
        option: "gesture",
        shortcut: "KeyG"
    },
    {
        display: <span><u>O</u>ption</span>,
        insert: (selected) => {
            return insertReplace(selected, "OPTION([option])");
        },
        option: "option",
        shortcut: "KeyO"
    },
    {
        display: <span><u>N</u>ote</span>,
        insert: (selected) => {
            return insertReplace(selected, "NOTE([note])");
        },
        option: "note",
        shortcut: "KeyN"
    },
    {
        display: <span><u>S</u>till</span>,
        insert: (selection) => {
            return insertReplace(selection, "STILL([image])");
        },
        option: "still",
        shortcut: "KeyS"
    },
    {
        display: <span><u>T</u>itle</span>,
        insert: (selected) => {
            return insertReplace(selected, "TITLE([title])");
        },
        option: "title",
        shortcut: "KeyT"
    }
];
